import { computed, inject, Signal } from '@angular/core';
import { Translation, TranslationService } from '../translation.service';
import { interpolate } from '@softline/core';


export function translator(): (key: string, interpolation?: object) => Signal<Translation> {
  const service = inject(TranslationService);
  return (key: string, interpolation?: object) => {
    const translation = service.translate(key);
    if(!interpolation)
      return translation;
    return computed(() => interpolate(translation(), interpolation) as Translation);
  }
}
